import React from 'react';
import { useParams } from 'react-router-dom';
import EntityUsersPage from '@features/user/pages/EntityUsersPage';

const NationUsersPage: React.FC = () => {
  const { nationId } = useParams<{ nationId: string }>();
  return (
    <EntityUsersPage
      scope="NATION"
      scopeRefId={Number(nationId)}
      title="Nation - Users"
      subtitle="People with roles at this nation"
      testId="nation-users-search"
    />
  );
};

export default NationUsersPage;
